import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";
import { IMAGES } from "./data";
import { scrollToId } from "@/lib/lenis";

export default function Hercules() {
  return (
    <section className="relative bg-ink py-24 lg:py-32" data-testid="hercules-brand-section">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 lg:grid-cols-2 lg:gap-20 lg:px-8">
        <Reveal className="order-2 lg:order-1">
          <div className="clip-corner relative overflow-hidden border border-line">
            <img
              src={IMAGES.facility}
              alt="Hercules Fitness equipment in a professional training facility"
              className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent" />
            <div className="absolute bottom-4 left-4 flex flex-wrap gap-2">
              <span className="bg-edge px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-white">
                Exclusive Showroom
              </span>
              <span className="border border-white/30 bg-black/50 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-white backdrop-blur-sm">
                Distributor — North Bengal, Sikkim, Bihar, Nepal & Bhutan
              </span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="order-1 lg:order-2">
          <Eyebrow>Hercules Fitness</Eyebrow>
          <SectionTitle>
            Exclusive <span className="text-edge">Hercules Fitness</span> Showroom
          </SectionTitle>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-ash sm:text-lg">
            Discover Hercules Fitness equipment and accessories at our exclusive
            showroom in Siliguri. Explore equipment designed for professional
            training environments as well as personal fitness spaces.
          </p>
          <ul className="mt-8 space-y-3">
            {[
              "Professional-grade training equipment",
              "Equipment for commercial gyms & home fitness",
              "Genuine Hercules Fitness range under one roof",
            ].map((point) => (
              <li key={point} className="flex items-center gap-3 text-sm text-ash">
                <span className="h-1.5 w-1.5 rotate-45 bg-edge" aria-hidden="true" />
                {point}
              </li>
            ))}
          </ul>
          <button
            onClick={() => scrollToId("#visit")}
            data-testid="hercules-visit-cta"
            className="clip-corner-sm group mt-10 inline-flex items-center gap-3 border border-edge px-8 py-4 font-display text-lg font-bold uppercase tracking-wider text-white transition-colors duration-200 hover:bg-edge"
          >
            Visit the Showroom
            <ArrowRight size={18} className="transition-transform duration-200 group-hover:translate-x-1" />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
